/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * What a planned container action was read from.
 */
export enum EnumPlannedActionSource {
    /**
     * An order of the mandant.
     */
    Order = 1,
    /**
     * The portal's snapshot of an order.
     */
    OrderSnapshot = 2,
    /**
     * A requisition that no order has been placed for yet.
     */
    Requisition = 3,
}
